import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.services';
import { ActivatedRoute, Router } from '@angular/router';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { ImageViewerComponent } from '../image-viewer/image-viewer.component';
import { ICustomerInquiryModel } from './property.modal';

@Component({
  selector: 'app-property-detail',
  templateUrl: './property-detail.component.html',
  styleUrl: './property-detail.component.css'
})
export class PropertyDetailComponent implements OnInit {

  propertyId: string = '';
  property: any;
  propertyTitleImageUri: string = '';
  resultLoaded: boolean = false;
  indoorAmenities: Array<any> = [];
  outdoorAmenities: Array<any> = [];
  otherAmenities: Array<any> = [];
  isContactSubmitted:boolean = false;
  isAgreeTermServiceCheck: boolean = false;
  inquiryData: ICustomerInquiryModel = {
    customerDetails:{
      customerId: '',
      firstName: '',
      lastName: '',
      email: '',
      phoneNo: ''
    },
    propertyDetails: {
      inquiryId: '',
      propertyId: '',
      inquiryCode: '',
      inquiryType: 'External',
      inquiryDetail: '',
      metaFormName:''
    }
  }; 

  constructor(private _apiService : ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog, 
  ){
    
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      console.log(params);
      this.propertyId = params.get('id') || '';
    
    this._apiService.getPropertyDetail(this.propertyId).subscribe((res) => {
      this.property = res.data;
      this.resultLoaded = true;
      if(!this.property.propertyAgent.userProfilePictureUri){
        this.property.propertyAgent.userProfilePictureUri = '../../assets/images/user-1.jpg'
      }
      var titleImage = this.property.mediaDetails.filter(i => i.isTitleImage)[0];
      if(titleImage){
        this.propertyTitleImageUri = titleImage.mediaUri;
      }
      else{
        this.propertyTitleImageUri = this.property.mediaDetails[0].mediaUri;
      }

      this.indoorAmenities = this.property.amenitiesDetails.filter(a => a.amenityType == 'Indoor');
      this.outdoorAmenities = this.property.amenitiesDetails.filter(a => a.amenityType == 'Outdoor');
      this.otherAmenities = this.property.amenitiesDetails.filter(a => a.amenityType == 'Other');
      
      console.log(this.property);
    });
  });
  }

  openImageDialog(): void {
    
    const dialogRef = this.dialog.open(ImageViewerComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      panelClass: 'full-screen-modal',
      data: this.property.mediaDetails.filter(x => x.mediaType == 'PropertyImage')
    });
    dialogRef.afterClosed().subscribe((result) => {
      
    });
  }

  goToContact(): void {
    console.log('get in touch');
    document.getElementById("First_name")?.focus();
  }

  savePropertyInquiry(): void {
    // Close the dialog and pass data back to the parent
    this.inquiryData.propertyDetails.propertyId = this.property.id;
    this._apiService.savePropertyInquiry(this.inquiryData).subscribe((res: any) => {
      this.isContactSubmitted = true;
      this.inquiryData = {
        customerDetails:{
          customerId: '',
          firstName: '',
          lastName: '',
          email: '',
          phoneNo: ''
        },
        propertyDetails: {
          inquiryId: '',
          propertyId: '',
          inquiryCode: '',
          inquiryType: 'External',
          inquiryDetail: '',
          metaFormName:''
        }
      }; 
    });
  }

  backToList(){
    if(this.property.type == 'Sales') {
      this.router.navigate(['/buy-properties']);
    }
    else{
      this.router.navigate(['/rent-properties']);
    }
  }

  isContactFormValid(): boolean{
    return (this.isAgreeTermServiceCheck && this.inquiryData.customerDetails.firstName != ''
      && this.inquiryData.customerDetails.phoneNo != ''
    )
  }

}
